import { gql } from '@apollo/client';

export const orderMoneysureQuery = gql`
  mutation Order($input: OrderInput!) {
    order(input: $input) {
      orderResult {
        orderId
      }
    }
  }
`;
